// extracted by mini-css-extract-plugin
var _1 = "W3whxQK73QlOT16f2GvO";
var _2 = "Cfm_nFcv8z2_iG7DFmtb";
var _3 = "rG5dSDh_PMdVPbpAVkeP";
var _4 = "oL7tPKlOQnbHke4F6tN1";
var _5 = "W3whxQK73QlOT16f2GvO";
var _6 = "Cfm_nFcv8z2_iG7DFmtb";
var _7 = "rG5dSDh_PMdVPbpAVkeP";
var _8 = "oL7tPKlOQnbHke4F6tN1";
export { _1 as "adviser-address", _2 as "adviser-control-label", _3 as "adviser-email", _4 as "adviser-name", _5 as "adviserAddress", _6 as "adviserControlLabel", _7 as "adviserEmail", _8 as "adviserName" }
